// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yPNR","select":"styles_select__232vS"};